// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UnprocessableEntityErrorSchema = z.object({
  errors: z.object({}).describe("Error details"),
});
